import React, { useContext, useEffect, useState } from 'react'
import { AuthContext, ThemeContext } from '../../../../auth';
import { useMediaQuery } from 'react-responsive';
import { Button, Card, Col, Form, Modal, Row, Spinner } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { IoAddCircle } from 'react-icons/io5';
import { MdDeleteForever } from 'react-icons/md';
import Select from 'react-select';
import { axiosAuth } from '../../../../api';

function ModalTambahCustomer({
    showAddCustomer,
    setShowAddCustomer,
    retrieveCustomer,
    accessToken,
}) {

    const { userInfo } = useContext(AuthContext);
    const isMobile = useMediaQuery({ maxWidth: 736 });
    const { theme } = useContext(ThemeContext);

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [disabled, setDisabled] = useState(false);

    const [customerTitle, setCustomerTitle] = useState([]);
    const [selectedTitle, setSelectedTitle] = useState(null);
    const [customerType, setCustomerType] = useState([]);
    const [selectedCustomerType, setSelectedCustomerType] = useState(null);
    const [customerName, setCustomerName] = useState('');
    const [customerPhone, setCustomerPhone] = useState('');
    const [customerEmail, setCustomerEmail] = useState('');
    const [contactPerson, setContactPerson] = useState('');
    const [customerNpwp, setCustomerNpwp] = useState('');


    const [showModalAddress, setShowModalAddress] = useState(false);

    const [addressData, setAddressData] = useState([]);
    const [isDefault, setIsDefault] = useState(false);
    const [addressType, setAddressType] = useState(null);
    const [pic, setPic] = useState('');
    const [phone, setPhone] = useState('');
    const [city, setCity] = useState('');
    const [province, setProvince] = useState('');
    const [postCode, setPostCode] = useState('');
    const [address, setAddress] = useState('');

    const handleAddressSubmit = (newAddress) => {
        const formattedAddress = {
            ...newAddress,
            addressType: addressType?.value || '',
        };

        setAddressData((prev) => (Array.isArray(prev) ? [...prev, formattedAddress] : [formattedAddress]));
        setShowModalAddress(false);

        setAddressType(null);
        setPic('');
        setPhone('');
        setCity('');
        setProvince('');
        setPostCode('');
        setAddress('');
    };

    const adressTypeOptions = [
        {
            value: 'Kantor',
            label: 'Kantor',
        },
        {
            value: 'Penagihan',
            label: 'Penagihan',
        },
        {
            value: 'Pengiriman',
            label: 'Pengiriman',
        },
    ];

    const handleSelectAddressType = (selectedOption) => {
        setAddressType(selectedOption);
    };


    const retrieveCustomerTitle = () => {

        axiosAuth.get(`/api/customers/titles`,
            {
                headers:
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Bearer ${accessToken}`,
                },

            })
            .then(res => {

                setCustomerTitle(res.data.data);

            }).catch(err => {
                console.error(err);

            })
    };

    const retrieveCustomerType = () => {

        axiosAuth.get(`/api/customers/types`,
            {
                headers:
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Bearer ${accessToken}`,
                },

            })
            .then(res => {

                setCustomerType(res.data.data);

            }).catch(err => {
                console.error(err);

            })
    };

    useEffect(() => {
        if (accessToken !== undefined) retrieveCustomerTitle();
        if (accessToken !== undefined) retrieveCustomerType();
    }, [accessToken]);

    const customerTitleOptions = customerTitle.map(type => ({
        value: type.id,
        label: type.titleName,
    }));

    const handleSelectCustomerTitle = (selectedOption) => {
        setSelectedTitle(selectedOption);
    };

    const customerTypeOptions = customerType.map(type => ({
        value: type.id,
        label: type.name,
    }));

    const handleSelectCustomerType = (selectedOption) => {
        setSelectedCustomerType(selectedOption);
    };

    const handleDeleteAddress = (index) => {
        const updatedAddressData = addressData.filter((_, idx) => idx !== index);
        setAddressData(updatedAddressData);
    };

    const handleShowModalAddress = () => {
        setShowModalAddress(true);
    };

    const handleClose = () => {
        setShowAddCustomer(false);
        setCustomerName('');
        setCustomerEmail('');
        setCustomerPhone('');
        setSelectedCustomerType(null);
        setAddressData([]);
    };

    const handleCloseModalAddress = () => {
        setShowModalAddress(false);
        setAddressType(null);
        setPic('');
        setPhone('');
        setCity('');
        setProvince('');
        setPostCode('');
        setAddress('');
    };

    const handleSubmitCustomer = async (event) => {

        event.preventDefault();
        setIsSubmitting(true);
        setDisabled(true);

        const dataCustomer = {
            username: userInfo?.username,
            name: customerName,
            phone: customerPhone,
            contactPerson: contactPerson,
            email: customerEmail,
            npwp: customerNpwp,
            customerTypeId: selectedCustomerType?.value,
            titleId: selectedTitle?.value,
        };

        try {

            const responseCustomer = await axiosAuth.post(`/api/customers`, dataCustomer, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Bearer ${accessToken}`,
                },
            });


            const dataCustomerAddress = addressData.map((address) => ({
                ...address,
                customerId: responseCustomer?.data.data.id,
                username: userInfo?.username,
            }));

            const responseCustomerAddress = await axiosAuth.post(`/api/customers/addresses`, dataCustomerAddress, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            handleClose();
            Swal.fire({
                icon: 'success',
                title: 'Berhasil menambahkan Customer',
                showConfirmButton: true,
            });
            retrieveCustomer();
            setIsSubmitting(false);
            setDisabled(false);

        } catch (err) {
            console.error(err);
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Terjadi kesalahan saat menambahkan Customer',
            });

            setIsSubmitting(false);
            setDisabled(false);

        } finally {

            setIsSubmitting(false);
            setDisabled(false);

        }
    };

    const modalStyle = {
        left: {
            position: 'absolute',
            top: isMobile ? '' : '50%',
            left: isMobile ? '' : '-33%',
            transform: isMobile ? '' : 'translateY(-50%)',
            overflow: 'hidden'
        },
        right: {
            position: 'absolute',
            top: isMobile ? '' : '50%',
            left: isMobile ? '' : '33%',
            transform: isMobile ? '' : 'translateY(-50%)',
        },
        center: {
            position: 'absolute',
            zIndex: 1200, // ensure it's above the backdrop
            backgroundColor: 'rgba(0, 0, 0, 0.6)'
        }
    };

    const formStyles = {
        label: {
            fontFamily: 'Poppins-Medium',
            color: theme === 'light' ? '#FFFFFF' : '#222222',
        },
        input: {
            color: theme === 'light' ? '#FFFFFF' : '#222222',
            fontFamily: 'Poppins-Regular',
            minHeight: '50px',
            borderColor: '#ced4da',
            background: theme === 'light' ? '#212529' : '#FFFFFF'
        },
    };


    const selectStyles = {
        control: (cityided, state) => ({
            ...cityided,
            minHeight: '50px',
            width: '100%', // make sure it stretches
            border: state.isFocused ? '1px solid #80bdff' : '1px solid #ced4da',
            boxShadow: state.isFocused ? '0 0 0 0.3rem rgba(0, 123, 255, 0.25)' : null,
            '&:hover': {
                borderColor: '#80bdff',
            },
            textAlign: 'left',
            fontFamily: 'Poppins-Regular',
            background: theme === 'light' ? '#212529' : '#FFFFFF',
        }),
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected ? '#fff' : '#333',
            background: state.isSelected ? '#007bff' : state.isFocused ? '#f5f5f5' : '#fff',
            fontFamily: 'Poppins-Regular',
        }),
        singleValue: (provided) => ({
            ...provided,
            color: theme === 'light' ? '#FFFFFF' : '#222',
            fontFamily: 'Poppins-Regular',
        }),
        input: (provided) => ({
            ...provided,
            color: theme === 'light' ? '#FFFFFF' : '#222',
            fontFamily: 'Poppins-Regular',
        }),
    };

    return (
        <Modal
            show={showAddCustomer}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            size="md"
            data-bs-theme={theme === 'light' ? 'dark' : ''}
        >
            <Modal.Header closeButton>
                <Modal.Title style={formStyles.label}>
                    Tambah Customer
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ maxHeight: '85vh', overflowY: 'auto', overflowX: 'hidden' }} >

                <Form onSubmit={handleSubmitCustomer} >
                    <Row >
                        <Col xs={7}>
                            <Form.Group className="mb-3">
                                <Form.Label style={formStyles.label} htmlFor='name'>Nama Customer*</Form.Label>
                                <Form.Control
                                    id='name'
                                    type='text'
                                    onChange={(e) => setCustomerName(e.target.value)}
                                    value={customerName}
                                    required
                                    style={formStyles.input}
                                    placeholder='Nama customer'
                                />
                            </Form.Group>
                        </Col>
                        <Col xs={5}>
                            <Form.Group className="mb-3">
                                <Form.Label style={formStyles.label} htmlFor='title'>Title*</Form.Label>
                                <Select
                                    id='customerType'
                                    options={customerTitleOptions}
                                    required
                                    value={selectedTitle}
                                    onChange={handleSelectCustomerTitle}
                                    styles={selectStyles}
                                    placeholder='Pilih title'
                                />
                            </Form.Group>
                        </Col>
                        <Col xs={12}>
                            <Form.Group className="mb-3">
                                <Form.Label style={formStyles.label} htmlFor='cp'>Contact Person*</Form.Label>
                                <Form.Control
                                    id='cp'
                                    type='text'
                                    onChange={(e) => setContactPerson(e.target.value)}
                                    value={contactPerson}
                                    required
                                    style={formStyles.input}
                                    placeholder='Contact Person'
                                />
                            </Form.Group>
                        </Col>
                        <Col xs={6} >
                            <Form.Group className="mb-3">
                                <Form.Label style={formStyles.label} htmlFor='customerPhone'>No. Telp*</Form.Label>
                                <Form.Control
                                    id='customerPhone'
                                    type='text'
                                    onChange={(e) => setCustomerPhone(e.target.value)}
                                    value={customerPhone}
                                    required
                                    style={formStyles.input}
                                    placeholder='No. telp'
                                />
                            </Form.Group>
                        </Col>
                        <Col xs={6}>
                            <Form.Group className="mb-3">
                                <Form.Label style={formStyles.label} htmlFor='email'>Email Customer*</Form.Label>
                                <Form.Control
                                    id='email'
                                    type='email'
                                    onChange={(e) => setCustomerEmail(e.target.value)}
                                    value={customerEmail}
                                    required
                                    style={formStyles.input}
                                    placeholder='Email'
                                />
                            </Form.Group>
                        </Col>
                        <Col xs={12}>
                            <Form.Group className="mb-3">
                                <Form.Label style={formStyles.label} htmlFor='customerType'>Tipe Customer*</Form.Label>
                                <Select
                                    id='customerType'
                                    options={customerTypeOptions}
                                    required
                                    value={selectedCustomerType}
                                    onChange={handleSelectCustomerType}
                                    styles={selectStyles}
                                    placeholder='Pilih tipe customer'
                                />
                            </Form.Group>
                        </Col>
                        <Col xs={12}>
                            <Form.Group className="mb-3">
                                <Form.Label style={formStyles.label} htmlFor='customerNpwp'>NPWP Customer</Form.Label>
                                <Form.Control
                                    id='customerNpwp'
                                    type='text'
                                    onChange={(e) => setCustomerNpwp(e.target.value)}
                                    value={customerNpwp}
                                    // required
                                    style={formStyles.input}
                                    placeholder='Npwp'
                                />
                            </Form.Group>
                        </Col>
                        <Col xs={12}>
                            <Form.Group className="mb-3">
                                <Row>
                                    <Col xs={12} md={6} className='text-start my-auto'>
                                        <Form.Label style={formStyles.label} >Alamat Customer*</Form.Label>
                                    </Col>
                                    <Col xs={12} md={6} className='text-end'>
                                        <IoAddCircle
                                            size={35}
                                            className='mb-3'
                                            onClick={handleShowModalAddress}
                                            color={theme === 'light' ? "#12B3ED" : '#006CB8'}
                                            style={{ cursor: 'pointer' }}
                                        />
                                    </Col>
                                </Row>
                                {addressData.length > 0 ? (

                                    <>
                                        {addressData.map((addr, idx) => (
                                            <Card className='mb-3' style={{ minHeight: '100px' }} key={idx}>
                                                <Card.Body>
                                                    <Row>
                                                        <Col xs={10} className='text-start'>
                                                            {addr?.isDefault ?
                                                                (
                                                                    <p className='mb-1' style={{ fontFamily: 'Poppins-Regular', fontSize: '17px', color: theme === 'light' ? '#12B3ED' : '#006CB8' }}>
                                                                        Alamat Utama*
                                                                    </p>
                                                                )
                                                                :
                                                                (
                                                                    <></>
                                                                )

                                                            }
                                                            <p className='mb-1' style={{ fontFamily: 'Poppins-Bold', fontSize: '18px' }}>
                                                                {addr.addressType}
                                                            </p>
                                                            <p className='mb-0' style={{ fontFamily: 'Poppins-Regular', fontSize: '16px' }}>
                                                                {addr.pic} ( {addr.phone} )
                                                            </p>
                                                            <p className='mb-0' style={{ fontFamily: 'Poppins-Regular', fontSize: '16px' }}>
                                                                {addr.address}
                                                            </p>
                                                            <p style={{ fontFamily: 'Poppins-Regular', fontSize: '16px' }}>
                                                                {addr.city},  {addr.province}, {addr.postCode}
                                                            </p>
                                                        </Col>
                                                        <Col xs={2} className='text-end my-auto'>
                                                            <MdDeleteForever
                                                                size={35}
                                                                onClick={() => handleDeleteAddress(idx)}
                                                                color='#FF0060'
                                                                style={{ cursor: 'pointer' }}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </Card.Body>
                                            </Card>
                                        ))}
                                    </>
                                ) : (
                                    <Card style={{ minHeight: '100px' }}>
                                        <Card.Body style={{ fontFamily: 'Poppins-Light' }}>
                                            Belum ada alamat.
                                        </Card.Body>
                                    </Card>
                                )}
                            </Form.Group>
                        </Col>
                    </Row>
                    <div className="d-grid gap-2 my-2">
                        {isSubmitting ? (
                            <Button
                                id={theme === 'light' ? 'actionButtonModalDark' : 'actionButtonModalLight'}
                                variant='btn'
                                disabled
                            >
                                <Spinner
                                    animation="border"
                                    size='sm'
                                />
                            </Button>
                        ) : (
                            <Button
                                type="submit"
                                id={theme === 'light' ? 'actionButtonModalDark' : 'actionButtonModalLight'}
                                variant='btn'
                                disabled={
                                    disabled ||
                                    !customerName ||
                                    !customerPhone ||
                                    !customerEmail ||
                                    !customerType ||
                                    !selectedCustomerType ||
                                    !selectedTitle ||
                                    addressData.length === 0
                                }
                            >
                                Simpan
                            </Button>
                        )}
                    </div>

                </Form>
            </Modal.Body>


            {/* Customer Address Modal */}
            <Modal
                show={showModalAddress}
                onHide={handleCloseModalAddress}
                backdrop="static"
                keyboard={false}
                size="md"
                style={modalStyle.right}
                data-bs-theme={theme === 'light' ? 'dark' : ''}
            >
                <Modal.Header closeButton>
                    <Modal.Title style={formStyles.label}>Tambah Alamat</Modal.Title>
                </Modal.Header>
                <Modal.Body style={formStyles.label}>
                    <Form
                        onSubmit={(e) => {
                            e.preventDefault();

                            const newAddress = {
                                addressType: addressType?.value || '',
                                pic,
                                phone,
                                city,
                                province,
                                postCode,
                                address,
                                isDefault
                            };

                            handleAddressSubmit(newAddress);
                        }}
                    >
                        <Row>
                            <Col xs={addressData.length !== 0 ? 12 : 7} lg={addressData.length !== 0 ? 12 : 8}>
                                <Form.Group className="mb-3">
                                    <Form.Label style={formStyles.label} htmlFor='addressType'>Tipe Alamat*</Form.Label>
                                    <Select
                                        id='addressType'
                                        options={adressTypeOptions}
                                        required
                                        value={addressType}
                                        onChange={handleSelectAddressType}
                                        styles={selectStyles}
                                        placeholder='Pilih tipe alamat'
                                    />
                                </Form.Group>
                            </Col>
                            {addressData.length !== 0 ?
                                (

                                    <></>
                                )
                                :
                                (
                                    <Col xs={5} lg={4} className="mb-3">
                                        <Form.Label style={formStyles.label}>Alamat Utama*</Form.Label>
                                        <Form.Check
                                            type='checkbox'
                                            id='default-checkbox'
                                            onChange={(e) => setIsDefault(e.target.checked)}
                                            value={isDefault}
                                            required
                                            style={formStyles.label}
                                            disabled={addressData.length !== 0}
                                        />
                                    </Col>
                                )
                            }
                            <Col xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label style={formStyles.label} htmlFor='pic'>PIC*</Form.Label>
                                    <Form.Control
                                        id='pic'
                                        type='text'
                                        onChange={(e) => setPic(e.target.value)}
                                        value={pic}
                                        required
                                        placeholder='Nama pic'
                                        style={formStyles.input}
                                    />
                                </Form.Group>
                            </Col>
                            <Col xs={12} md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label style={formStyles.label} htmlFor='phone'>Phone*</Form.Label>
                                    <Form.Control
                                        id='phone'
                                        type='text'
                                        onChange={(e) => setPhone(e.target.value)}
                                        value={phone}
                                        required
                                        placeholder='Phone'
                                        style={formStyles.input}
                                    />
                                </Form.Group>
                            </Col>
                            <Col xs={12} md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label style={formStyles.label} htmlFor='city'>Kota*</Form.Label>
                                    <Form.Control
                                        id='city'
                                        type='text'
                                        onChange={(e) => setCity(e.target.value)}
                                        value={city}
                                        required
                                        placeholder='Kota'
                                        style={formStyles.input}
                                    />
                                </Form.Group>
                            </Col>
                            <Col xs={12} md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label style={formStyles.label} htmlFor='province'>Provinsi*</Form.Label>
                                    <Form.Control
                                        id='province'
                                        type='text'
                                        onChange={(e) => setProvince(e.target.value)}
                                        value={province}
                                        required
                                        placeholder='Provinsi'
                                        style={formStyles.input}
                                    />
                                </Form.Group>
                            </Col>
                            <Col xs={12} md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label style={formStyles.label} htmlFor='postCode'>Kode Pos*</Form.Label>
                                    <Form.Control
                                        id='postCode'
                                        type='text'
                                        onChange={(e) => setPostCode(e.target.value)}
                                        value={postCode}
                                        required
                                        placeholder='Kode pos'
                                        style={formStyles.input}
                                    />
                                </Form.Group>
                            </Col>
                            <Col xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label style={formStyles.label} htmlFor='detailAddress'>Detail Alamat*</Form.Label>
                                    <Form.Control
                                        id='detailAddress'
                                        as='textarea'
                                        rows={5}
                                        onChange={(e) => setAddress(e.target.value)}
                                        value={address}
                                        required
                                        placeholder='Detail alamat'
                                        style={formStyles.input}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <div className="d-grid gap-2 my-2">
                            {isSubmitting ? (
                                <Button
                                    id={theme === 'light' ? 'actionButtonModalDark' : 'actionButtonModalLight'}
                                    variant='btn'
                                    disabled
                                >
                                    <Spinner
                                        animation="border"
                                        size='sm'
                                    />
                                </Button>
                            ) : (
                                <Button
                                    type="submit"
                                    id={theme === 'light' ? 'actionButtonModalDark' : 'actionButtonModalLight'}
                                    variant='btn'
                                    disabled={
                                        disabled ||
                                        !addressType ||
                                        !pic ||
                                        !phone ||
                                        !city ||
                                        !province ||
                                        !postCode ||
                                        !address
                                    }
                                >
                                    Simpan
                                </Button>
                            )}
                        </div>
                    </Form>
                </Modal.Body>

            </Modal>
            {/* Customer Address Modal */}

        </Modal>
    )
}

export default ModalTambahCustomer
